import { RouterModule, Routes } from '@angular/router';
import {MainComponent} from "../../layouts/main/main.component";
import {IndexComponent} from "./index/index.component";


const routes: Routes = [
    {
        path: 'self-assessment-form',
        component: MainComponent,
        children: [
          {
            path: '',
            component: IndexComponent
          },
        ]
    }
];

export const selfAssessmentFormRouting = RouterModule.forChild(routes);
